import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';

import {
  AssetPathModule,
  NumericDateFormatModule,
  NumericDateFormatPipe,
  RouterHelperService
} from '@hdms/shared/util-core';

import { TranslationModule } from '../translation/translation.module';

@Component({
  selector: 'shrd-ft-header-print-layout',
  templateUrl: './header-print-layout.component.html',
  styleUrls: ['./header-print-layout.component.scss'],
  standalone: true,
  imports: [AssetPathModule, TranslationModule, NumericDateFormatModule]
})
export class HeaderPrintLayoutComponent {
  protected readonly pageTitle = inject(Title).getTitle();
  protected readonly finalUrl = inject(RouterHelperService).finalUrl;
  private readonly datePipe = inject(NumericDateFormatPipe);

  protected generationDate: string;

  constructor() {
    this.generationDate = this.getGenerationDate();
  }

  private getGenerationDate(): string {
    const now = new Date(Date.now());
    const date = this.datePipe.transform(now);
    return `${date}, ${now.toLocaleTimeString()}`;
  }
}
